import TextField from "@mui/material/TextField";

const TextArea = ({ value, placeholderText, onChange, error }) => {
    return (
        <TextField
            multiline
            fullWidth
            rows={4}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            error={!!error}
            helperText={error}
            placeholder={placeholderText || `example: “Kitchen tap leaking under sink. Started yesterday. Easy access.”`}
            variant="outlined"
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: "#f5f5f5",
                    padding: "20px",
                    alignItems: "flex-start",
    
                    "& fieldset": {
                        border: "1px solid #e5e5e5",
                    },
    
                    "&:hover fieldset": {
                        borderColor: "#d0d0d0",
                    },
    
                    "&.Mui-focused fieldset": {
                        borderColor: "#bdbdbd",
                        borderWidth: "1px",
                    },
    
                    textarea: {
                        color: "#555",
                        fontSize: "15px",
                        lineHeight: 1.7,
                    },
    
                    "textarea::placeholder": {
                        color: "#b5b5b5",
                        opacity: 1,
                        fontSize: "15px",
                        lineHeight: 1.7,
                    },
                },
    
                "& .MuiFormHelperText-root": {
                    marginLeft: "8px",
                    marginTop: "6px",
                },
            }}
        />
    );
};

export default TextArea;